const envMode = process.env.NODE_ENV ? process.env.NODE_ENV : "development"
export const devMode = envMode === "development"

export default devMode
